import AlYusrAxiosApiInstance from "../axios/alYusrAxiosApiInstance";
import {AlYuserApiUrls} from "../configuration";
import {ResponseBaseModel,ApiGenericSystemConfigurationModel} from "../models";
//#region get
export const getClientGenericConfiguration = async (): Promise<ResponseBaseModel<ApiGenericSystemConfigurationModel[]> > => {
    return  await AlYusrAxiosApiInstance.get(AlYuserApiUrls.configurationController.getAllClientConfiguration);
    //return mapApiResponseToConfig(response)
};
//#endregion
